// fetch-utils.ts
import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';

export const authenticatedFetch = async (url: string, options: RequestInit = {}) => {
  try {
    const session = await fetchAuthSession();
    const refreshedToken = session.tokens?.accessToken;

    if (!refreshedToken) {
      throw new Error('Failed to refresh token after 403 error');
    }

    // Get new token
    const token = refreshedToken.toString();

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    const headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(url, {
      ...options,
      headers,
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
